/*
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2023-11-20 16:22:03
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
// import nativeJSBridge from '@/utils/nativeJSBridge'
import store from './store'
import "amfe-flexible" // 引入flexible
import Vant from 'vant-ui';  // 引入vant-ui。
import 'vant/lib/index.css';
import config from '@/config/index'

import './assets/iconfont/iconfont.css'
import '@vant/touch-emulator';

// // 引入vue-UUID组件
// import UUID from 'vue-uuid'
// Vue.use(UUID)

Vue.use(Vant);

import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})

import './permission' // permission control
// console.log(`run in ${process.env.NODE_ENV}`)

// import signature from './packages/index'
// Vue.use(signature)

//设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false
new Vue({
    router,
    // nativeJSBridge,
    store,
    render: h => h(App),
}).$mount('#app')

Vue.prototype.exportDownLoad = function(params) {
  // window.open(process.env.VUE_APP_BASE_API + exportUrl + '?' + qs.stringify(params, { indices: false }))
  // 使用 form 表单模拟提交
  const _reportForm = document.createElement("form");
  document.body.appendChild(_reportForm); // 加入到body中
  _reportForm.method = params.responseType || "get";
  _reportForm.action = config.devProxy + params.url;
  _reportForm.target = "_blank";

  if (typeof params === "object") {
    for (const key in params) {
      // 遍历json对象的每个key/value对
      const paraElement = document.createElement("input");
      paraElement.setAttribute("name", key);
      paraElement.setAttribute("type", "hidden");
      paraElement.setAttribute("value", params[key]);
      _reportForm.appendChild(paraElement);
      console.log("文件输出", params, _reportForm.action, _reportForm);
    }
    _reportForm.submit();
    setTimeout(() => {
      document.body.removeChild(_reportForm);
      // _reportForm = null;
    });
  }
};